import { NavLink } from 'react-router-dom';
import { PrefetchNavLink } from '../ui/PrefetchLink';
import styled from 'styled-components';

const Nav = styled.nav`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding: 0 2rem;

  @media (max-width: 1023px) {
    gap: 1.25rem;
    padding: 0 1.5rem;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    padding: 0 1rem;
  }

  @media (max-width: 479px) {
    gap: 0.5rem;
    padding: 0 0.75rem;
  }
`;

const NavButton = styled(NavLink)`
  padding: 0.875rem 2rem;
  border: 2px solid var(--action-primary);
  background: var(--surface);
  color: var(--action-primary);
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 48px;
  min-width: 140px;

  &:hover {
    background: var(--brand-50);

    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  &.active {
    background: var(--action-primary);
    color: #fff;
    box-shadow: 0 4px 16px rgba(59, 138, 90, 0.4);
  }

  &:focus {
    outline: 3px solid var(--brand-50);
    outline-offset: 2px;
  }

  @media (max-width: 1023px) {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    min-width: 120px;
  }

  @media (max-width: 767px) {
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
    min-width: auto;
    width: 100%;
  }

  @media (max-width: 479px) {
    padding: 1rem;
    font-size: 0.9rem;
    min-height: 44px;
  }
`;

/**
 * Navigation - Main application navigation component
 *
 * Features:
 * - React Router NavLink integration with active states
 * - Desktop-first responsive design (horizontal by default, vertical on mobile)
 * - Accessible navigation with proper focus management
 * - Smooth hover and active state transitions
 * - Enhanced desktop presentation with better spacing and typography
 * - Mobile-optimized touch targets and layouts
 */
export const Navigation: React.FC = () => {
  return (
    <Nav role="navigation" aria-label="Main navigation">
      <NavButton to="/" end>
        <span role="img" aria-label="Home">
          🏠
        </span>
        Panel
      </NavButton>
      <NavButton as={PrefetchNavLink} to="/upload">
        <span role="img" aria-label="Upload">
          📤
        </span>
        Escanear Factura
      </NavButton>
      <NavButton as={PrefetchNavLink} to="/manual">
        <span role="img" aria-label="Manual entry">
          ✏️
        </span>
        Entrada Manual
      </NavButton>
    </Nav>
  );
};
